import { Link } from "react-router-dom";
import "@fontsource/poppins";
import about from "../../assets/img/about.webp"
import TestimonialCarousel from "./TestimonialCarousel";
import Registration from "./Registration";
import imgHeader from "../../assets/img/page-header.webp";

const About = () => {
    return (
        <>
            {/* Header Section */}
            <div className="w-100 overflow-hidden mb-5 position-relative" style={{ minHeight: '300px' }}>
                <img
                    src={imgHeader}
                    alt="Encabezado de página curso online"
                    className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
                    style={{ zIndex: 0 }}
                    loading="eager"
                    decoding="async"
                />

                <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'rgba(0, 0, 0, 0.5)', zIndex: 1 }}></div>

                <div className="container position-relative" style={{ zIndex: 2 }}>
                    <div className="d-flex flex-column justify-content-center h-100" style={{ minHeight: '300px' }}>
                        <h3 className="display-4 text-white text-uppercase">Acerca de</h3>
                        <div className="d-inline-flex text-white">
                            <p className="m-0 text-uppercase">
                                <Link to="/">Inicio</Link>
                            </p>
                            <i className="fa fa-angle-double-right pt-1 px-3"></i>
                            <p className="m-0 text-uppercase">Acerca de</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* About Section */}
            <div className="container-fluid py-5">
                <div className="container py-5">
                    <div className="row align-items-center">
                        <div className="col-lg-5">
                            <img className="img-fluid rounded mb-4 mb-lg-0" src={about} alt="Acerca de" />
                        </div>
                        <div className="col-lg-7">
                            <div className="text-title-about mb-4">
                                <h5 className="text-primary text-uppercase mb-3" style={{ letterSpacing: "5px" }}>Acerca de</h5>
                                <h1>Una forma innovadora de aprender</h1>
                            </div>
                            <p>
                                La educación online ha transformado el panorama del aprendizaje, ofreciendo una forma innovadora de aprender
                                que rompe las barreras geográficas y de tiempo...
                            </p>
                            <Link to="/cursos" className="btn btn-primary py-md-2 px-md-4 font-weight-semi-bold mt-2">
                                Quiero ver los cursos
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* Registration Start */}
            <Registration />
            {/* Registration End */}

            {/* Testimonial Start */}
            <TestimonialCarousel />
            {/* Testimonial End */}
        </>
    );
};

export default About;
